import { useTranslation } from "react-i18next";
import { SupplierPicker } from "./SupplierPicker";
import { BuilderTerms } from "./BuilderTerms";
import { BuilderDelivery } from "./BuilderDelivery";

// رأس مستند الشراء: مورّد (بحث حي) · تواريخ · شروط دفع · فرع ومخزن التسليم.
export const BuilderHead = ({ head, onChange, needsSupplier }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <label className="grid gap-1.5 sm:col-span-2">
        <span className="text-[11px] font-bold text-muted-foreground">
          {t("purchases.pickSupplier")}
        </span>
        <SupplierPicker testid="purchase-supplier" value={head.supplier_id}
                        allowEmpty={!needsSupplier}
                        onChange={(id) => onChange({ ...head, supplier_id: id })} />
      </label>
      <BuilderTerms head={head} onChange={onChange} needsSupplier={needsSupplier} />
      {needsSupplier ? <BuilderDelivery head={head} onChange={onChange} /> : null}
    </div>
  );
};
